import AuthLayout from '@/app/layout/authLayout'
import { VerifyEmail } from '@/app/entities/auth/ui/registration/VerifyEmail'

export const VerifyEmailPage = () => {
    return (
        <AuthLayout>
            <VerifyEmail />
        </AuthLayout>
    )
}
